import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import StudyInformation from '../components/study-information/StudyInformation';
import StudyDocuments from '../components/study-information/StudyDocuments';
import { getStudyById } from '../api/studiesAPI';
import StudyQCTForm from '../components/forms/StudyQCTForm';
import StudyDetailTour from '../components/ui/StudyDetailTour';
import Loader from '../components/ui/Loader';

import './StudyDetail.scss';

const StudyDetailPage = () => {
	const { studyId } = useParams();

	const {
		isLoading,
		isError,
		error,
		data: studyData
	} = useQuery({
		queryKey: ['study', studyId],
		queryFn: () => getStudyById(studyId),
		retry: false,
		staleTime: 3000000 //5 minutes to refetch
	});

	if (isLoading || !studyData) {
		return <Loader centered />;
	} else if (isError) {
		return <div>Error fetching post: {error.message}</div>;
	} else {
		const { study } = studyData.data;
		return (
			<>
				<StudyDetailTour />
				<div className='study-detail-content-container'>
					<StudyInformation
						title={study.title}
						type={study.type}
						status={study.status}
						sponsor={study.sponsor}
						version={study.version}
						qam={study.qam}
						deparment={study.department}
						time={
							study.time ? study.time.split('T')[0] : ''
						}
						pi={study.pi}
						fundingType={study.fundingType}
						phaseOfStudy={study.phaseOfStudy}
						nationalClinicalTrial={
							study.nationalClinicalTrial
						}
						informedConsentFormDate={
							study.informedConsentFormDate
								? study.informedConsentFormDate.split(
										'T'
									)[0]
								: ''
						}
						iRBApprovalDate={
							study.IRBApprovalDate
								? study.IRBApprovalDate.split('T')[0]
								: ''
						}
						cRFOBudgetReviewCompletedDate={
							study.CRFOBudgetReviewCompletedDate
								? study.CRFOBudgetReviewCompletedDate.split(
										'T'
									)[0]
								: ''
						}
						filled={study.filled}
						id={study._id}
						protocolFileName={study.protocol[0]}
						billingGrid={study.billingGrid}
						issue={study.issue || ''}
					/>
					<br />
					<br />
					<br />
					<StudyDocuments
						cretationDate={
							study.time ? study.time.split('T')[0] : ''
						}
						budget={study.budget}
						informedConsentForm={study.informedConsentForm}
						otherDocuments={study.otherDocuments}
						protocol={study.protocol}
						qamId={study.qam._id}
					/>
					<br />
					<div>
						{study.processed === true ? (
							<StudyQCTForm studyId={study._id} />
						) : (
							<div>The study is being processed... </div>
						)}
					</div>
				</div>
			</>
		);
	}
};
export default StudyDetailPage;
